import { Avatar } from '@homebotapp/hb-react-component-catalog'
import styles from './AvatarBubblesSmall.module.scss'
import classnames from 'classnames'

type AvatarBubblesSmallProps = {
  photoUri?: string | null
  companyLogo?: string | null
}

export const AvatarBubblesSmall = ({ photoUri, companyLogo }: AvatarBubblesSmallProps) => {
  return (
    <div className={styles.avatarContainer}>
      <div className={styles.bgCircle} />
      <div className={styles.bgSmallCircle} />
      <div className={styles.avatarOverlap}>
        <Avatar className={classnames(styles.avatar, companyLogo && styles.avatarShifted)} src={photoUri} />
        {companyLogo && <Avatar className={classnames(styles.avatar, styles.avatarShifted)} src={companyLogo} />}
      </div>
    </div>
  )
}
